import React from "react";
import SettingsPage from "../../components/Design/Settings/SettingsPage";
import SettingsPageContent from "../../components/Design/Settings/SettingsPageContent";
import { useApiStates } from "../../state/Store";
import RoleTable from "./RoleTable";

const RoleScreen: React.FC = () => {
    const api = useApiStates("roles");

    return (
        <SettingsPage title="Rollen">

            <SettingsPageContent api={api}>

                <RoleTable roles={api.roles.value ?? []}/>

            </SettingsPageContent>

        </SettingsPage>
    );
};

export default RoleScreen;
